import type ModalConversationInterceptorService from 'src/modals/modal-conversation-interceptor.service';

export class DiscountInterceptorRegistrar {

    constructor(private modalConversationInterceptor: ModalConversationInterceptorService) {
    }

    public register() {
        this.modalConversationInterceptor.registerDiscountRequestExceptionHandler('DiscountRequestShowException');
    }
}